export default "__VITE_ASSET__BQeTsJrv__"